module.exports = __webpack_public_path__ + "img/logo.191c778b.png";